
export default {
  props: {
    current: {
      type: String,
      default: null
    }
  },
  vessel: {
    title: {
      marginBottom: 'md',
      fontSize: '2xl'
    }
  }
}
